import Vue from 'vue'
import Router from 'vue-router'

// 404
const NotFound = () =>
  import(/* webpackChunkName: "notFound" */ '@/views/404/404')

// 账号
const Login = () =>
  import(/* webpackChunkName: "account" */ '@/views/account/Login')
const BindPhone = () =>
  import(/* webpackChunkName: "account" */ '@/views/account/BindPhone')

// 订单
const OrderList = () =>
  import(/* webpackChunkName: "order" */ '@/views/my/order/OrderList')
const OrderDetail = () =>
  import(/* webpackChunkName: "order" */ '@/views/my/order/OrderDetail')
const OrderConfirm = () =>
  import(/* webpackChunkName: "order" */ '@/views/my/order/OrderConfirm')

// 收货地址
const AddressList = () =>
  import(/* webpackChunkName: "address" */ '@/views/my/address/AddressList')
const AddressUpdate = () =>
  import(/* webpackChunkName: "address" */ '@/views/my/address/AddressUpdate')

// 积分
const CreditLottery = () =>
  import(/* webpackChunkName: "credit" */ '@/views/my/credit/Lottery')
const CreditPrize = () =>
  import(/* webpackChunkName: "credit" */ '@/views/my/credit/Prize')

// 直播
const LiveRoom = () =>
  import(/* webpackChunkName: "live" */ '@/views/live/LiveRoom')

// 商城
const ShopItem = () =>
  import(/* webpackChunkName: "shop" */ '@/views/shop/ShopItem')

// 课程详情
const courseDetails = () =>
  import(/* webpackChunkName: "details" */ '@/views/course/courseDetails')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    { path: '*', redirect: '/404' },

    // 404
    { path: '/404', name: 'NotFound', component: NotFound },

    // 首页
    { path: '/', redirect: '/Login' },

    // 登录
    { path: '/login', name: 'Login', component: Login },
    // 绑定手机号
    { path: '/bindphone', name: 'BindPhone', component: BindPhone },

    // 订单
    { path: '/my/order', name: 'OrderList', component: OrderList },
    // 订单详情
    { path: '/my/order/item/:id', name: 'OrderDetail', component: OrderDetail },
    // 确认订单
    {
      path: '/my/order/confirm',
      name: 'OrderConfirm',
      component: OrderConfirm
    },

    // 收货地址
    { path: '/my/address', name: 'AddressList', component: AddressList },
    { path: '/my/address/add', name: 'AddressAdd', component: AddressUpdate },
    {
      path: '/my/address/update/:id',
      name: 'AddressUpdate',
      component: AddressUpdate
    },

    // 积分抽奖
    {
      path: '/my/credit/lottery',
      name: 'CreditLottery',
      component: CreditLottery
    },
    // 已抽中奖品
    { path: '/my/credit/prize', name: 'CreditPrize', component: CreditPrize },

    // 直播间
    { path: '/live/room', name: 'LiveRoom', component: LiveRoom },
    { path: '/live/room/:id', name: 'LiveRoomQ', component: LiveRoom },

    // 商城
    { path: '/shop/item', name: 'ShopItem', component: ShopItem },
    { path: '/shop/item/:id', name: 'ShopItemQ', component: ShopItem },

    //课程详情
    { path: '/course/detail', name: 'courseDetails', component: courseDetails }
  ]
})
